export default "__VITE_PUBLIC_ASSET__3d3e8099__"